import { AfterViewInit,Component, Inject, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { MatTable } from '@angular/material/table';
import { Escenario } from 'app/main/models/escenario.model';
import { DimensionRiesgo } from 'app/main/models/dimension-riesgo.model';
import { Probabilidad } from 'app/main/models/probabilidad.model';
import { Impacto } from 'app/main/models/impacto.model';
import { ObjetivoRiesgo } from 'app/main/models/objetivo-riesgo.model';
import { AnalisisInherente} from 'app/main/models/analisis-inherente.model';
import { AnalisisResidual} from 'app/main/models/analisis-residual.model';

const Parser = require('expr-eval').Parser;

@Component({
  selector: 'app-dialog-box',
  templateUrl: './add-a-inherente-dialog-box.component.html',
  styleUrls: ['./add-a-inherente-dialog-box.component.scss']
})
export class AddAInherenteDialogBoxComponent {

  action: string;
  new_line_p: AnalisisInherente = {id:null,probabilidad:null,categoria:'',dimension:null,
                                  impacto:null,exposicion:2,clasificacion:'Atención'};

  new_line_r: AnalisisResidual = {id:null,control:null,nodo:null,estructura:null,costo:'',
                        nodoNombre:'', nodoEstructuraNombre:'',
                        esfuerzo:'',clasificacion:'',exposicion:0,impacto:null,probabilidad:null};


  dataSource: AnalisisInherente[] = [];
  objetivoRiesgo : ObjetivoRiesgo = null;
  escenario : Escenario = null;
  probabilidad : Probabilidad = null;
  dimensiones: DimensionRiesgo[] = [];
  dimension:DimensionRiesgo = null;
  categorias: any[] = [];
  indexE: number = -1;
  tiposClasificacion = ['Inaceptable','Atención'];

  displayedColumns: string[] = ['probabilidad','descripcion','categoria','impacto','exposicion','clasificacion','action'];

  @ViewChild('tableProbabilidad', {static: true}) tableProbabilidad: MatTable<any>;

  constructor(
    public dialogRef: MatDialogRef<AddAInherenteDialogBoxComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    
    this.action = data.objetivoRiesgo.action;
    this.objetivoRiesgo = data.objetivoRiesgo;
    this.escenario = data.escenario;
    this.dimensiones = data.dimensiones;
    this.dimension = data.dimensiones[0];
    this.categorias = this.dimension.categorias.sort((a, b) => (a > b) ? 1 : -1);

    if(data.objetivoRiesgo.topAnalisisInherente!=null){
      this.probabilidad = data.objetivoRiesgo.topAnalisisInherente.probabilidad;
    }

    /*this.dimensiones.forEach(dimension => {
      dimension.categorias.sort((a, b) => (a > b) ? 1 : -1);
    });*/

    this.escenario.probabilidades.sort((a, b) => (a.valor > b.valor) ? 1 : -1);


    //this.objetivoRiesgo.analisisInherente = data.objetivoRiesgo.analisisInherente || [];
    //console.log(this.probabilidades);
    //this.action = this.LOCAL_DATA.action;
    //Object.assign(this, { multi });
  }

  doAction(): void{

    this.objetivoRiesgo.topAnalisisInherente= null;

    for(var i=0; this.objetivoRiesgo.analisisInherente.length>i;i++){

      if(this.objetivoRiesgo.topAnalisisInherente == null ||
          this.objetivoRiesgo.analisisInherente[i].exposicion> this.objetivoRiesgo.topAnalisisInherente.exposicion)
          this.objetivoRiesgo.topAnalisisInherente = this.objetivoRiesgo.analisisInherente[i];
          if(this.objetivoRiesgo.analisisResidual.length==0 && this.objetivoRiesgo.topAnalisisInherente!=null){
            this.new_line_r.probabilidad = this.objetivoRiesgo.topAnalisisInherente.probabilidad;
            this.new_line_r.impacto = this.objetivoRiesgo.topAnalisisInherente.impacto;
            this.new_line_r.exposicion = this.objetivoRiesgo.topAnalisisInherente.exposicion;
            this.new_line_r.clasificacion = this.objetivoRiesgo.topAnalisisInherente.clasificacion;
            this.objetivoRiesgo.analisisResidual.push(this.new_line_r);
          }
    }

    this.actualizarAnalisisResidual();


    this.dialogRef.close({event: this.action, data: this.objetivoRiesgo});
  }

  actualizarAnalisisResidual(){

    for(var i=0; this.objetivoRiesgo.analisisResidual.length>i;i++){

      if(this.objetivoRiesgo.analisisResidual[i].exposicion> this.objetivoRiesgo.topAnalisisInherente.exposicion)
          this.objetivoRiesgo.analisisResidual[i].exposicion = this.objetivoRiesgo.topAnalisisInherente.exposicion;
          this.objetivoRiesgo.analisisResidual[i].probabilidad = this.objetivoRiesgo.topAnalisisInherente.probabilidad;
          this.objetivoRiesgo.analisisResidual[i].impacto = this.objetivoRiesgo.topAnalisisInherente.impacto;
          this.objetivoRiesgo.analisisResidual[i].clasificacion = this.objetivoRiesgo.topAnalisisInherente.clasificacion;
    }

    this.objetivoRiesgo.topAnalisisResidual = null;
    for(var i=0; this.objetivoRiesgo.analisisResidual.length>i;i++){

      if(this.objetivoRiesgo.topAnalisisResidual == null || this.objetivoRiesgo.topAnalisisResidual.exposicion ==0 ||
          this.objetivoRiesgo.analisisResidual[i].exposicion< this.objetivoRiesgo.topAnalisisResidual.exposicion)
          this.objetivoRiesgo.topAnalisisResidual = this.objetivoRiesgo.analisisResidual[i];
    }

  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel',riesgo:this.objetivoRiesgo});
  }


  remove(probabilidad: any,indexO:number): void {

    this.objetivoRiesgo.analisisInherente.splice(indexO, 1);
    this.objetivoRiesgo.analisisInherente = [...this.objetivoRiesgo.analisisInherente];

  }

  addLine():void{

    if(this.objetivoRiesgo.analisisInherente == undefined){
      this.objetivoRiesgo.analisisInherente = [];
    }

    //Si no tiene index, pero existe el valor para la categoria, se busca el indice para esa categoria.
    if(this.indexE==-1){
      var contador = 0;
      this.objetivoRiesgo.analisisInherente.forEach(element => {
          if(element.categoria===this.new_line_p.categoria ){
            this.indexE= contador;
          }
          contador+=1;
      });
    }

    if(this.indexE>=0){
        this.objetivoRiesgo.analisisInherente[this.indexE].categoria = this.new_line_p.categoria;
        this.objetivoRiesgo.analisisInherente[this.indexE].impacto = this.new_line_p.impacto;
        this.objetivoRiesgo.analisisInherente[this.indexE].dimension = this.dimension;
        var calculoAInherenteNuevo = this.updateProbabilidad(this.objetivoRiesgo.analisisInherente[this.indexE]);
        this.objetivoRiesgo.analisisInherente[this.indexE] = calculoAInherenteNuevo;
    }

    // Add our fruit
    if(this.indexE==-1) {

      this.new_line_p.categoria = this.new_line_p.categoria;
      this.new_line_p.impacto = this.new_line_p.impacto;
      this.new_line_p.dimension = this.dimension;
      var calculoAInherenteNuevo = this.updateProbabilidad(this.new_line_p);
      this.new_line_p = calculoAInherenteNuevo;
      this.objetivoRiesgo.analisisInherente.push(this.new_line_p);
    }

    this.tableProbabilidad.renderRows();

    this.new_line_p = {id:null,categoria:'',clasificacion:'',exposicion:0,dimension:null,impacto:null,probabilidad:null};
    this.indexE = -1;
  }

  edit(probabilidad: any,indexO:number):void{
    // Add our fruit
    this.indexE = indexO;
    this.new_line_p = {id:probabilidad.id,
                        probabilidad: probabilidad.probabilidad,
                        categoria:probabilidad.categoria,
                        dimension:probabilidad.dimension,
                        impacto: probabilidad.impacto,
                        exposicion: probabilidad.exposicion,
                        clasificacion: probabilidad.clasificacion};
  }

  probabilidadChange():void{

    for(var i=0; this.objetivoRiesgo.analisisInherente.length>i;i++){

      this.objetivoRiesgo.analisisInherente[i] = this.updateProbabilidad(this.objetivoRiesgo.analisisInherente[i]);

    }

    this.objetivoRiesgo.analisisInherente = [...this.objetivoRiesgo.analisisInherente];
  }

  updateProbabilidad(analisisInherente):AnalisisInherente{

    var clonado: AnalisisInherente = new AnalisisInherente(analisisInherente);
    clonado.probabilidad =  this.probabilidad;
    const parser = new Parser();
    var expression = parser.parse(this.escenario.formulaDeExposicion);
    var exposicion = expression.evaluate({ P: this.probabilidad.valor, I: clonado.impacto.valor });
    clonado.exposicion = exposicion;

    var clasificacion = "Aceptable";
    if(exposicion>=this.escenario.apetito)
      clasificacion = "Atención";

      if(exposicion>=this.escenario.tolerancia)
        clasificacion = "Inaceptable";

    clonado.clasificacion = clasificacion;

    return clonado;
  }
  /*
  calcularResultados(){
      this.objetivoRiesgo.analisisInherenteR = [];
      this.multi = [];

      if(this.LOCAL_DATA.formulaDeExposicion!=null){

        for(var i=0; this.objetivoRiesgo.analisisInherente.length>i;i++){

            var chartV ={"name": this.objetivoRiesgo.analisisInherente[i].nombre +" ("+this.objetivoRiesgo.analisisInherente[i].valor+")",
                          "series": []
                          };

          for(var z=0; this.objetivoRiesgo.analisisInherenteI.length>z;z++){
            const parser = new Parser();
            //let expr = parser.parse('2 * x + 1');
            //console.log(expr.evaluate({ x: 3 })); // 7
            var expression = parser.parse(this.LOCAL_DATA.formulaDeExposicion);
            var result = expression.evaluate({ P: this.objetivoRiesgo.analisisInherente[i].valor, I:this.objetivoRiesgo.analisisInherenteI[z].valor });
            this.objetivoRiesgo.analisisInherenteR.push({probabilidad:this.objetivoRiesgo.analisisInherente[i], impacto:this.objetivoRiesgo.analisisInherenteI[z],resultado:result});
            chartV["series"].push(
                                  {"name":this.objetivoRiesgo.analisisInherenteI[z].nombre +" ("+this.objetivoRiesgo.analisisInherenteI[z].valor+")",
                                  "value":result
                                });
          }

          this.multi.push(chartV);
        }

        this.tableResultados.renderRows();
      }
  }*/

  ngOnInit(): void {

  }

}
